<cerrix-icon-viewer
    [icon]="value"
    [detailed]="!pickeronly"
    (onClick)="openModal(iconPickerTemplate)"
    #iconViewer
>
</cerrix-icon-viewer>

<ng-template #iconPickerTemplate>
    <div class="icon-picker">
        <div class="left-menu">
            <div class="filter">
                <div class="input-group">
                    <input
                        type="text"
                        [placeholder]="'cerrixIconPicker.searchPlaceholder' | transloco"
                        class="form-control form-control-sm"
                        (debounce-input-event)="filter(selectedCategory ? true : false)"
                        [(ngModel)]="searchFilter"
                        inputTooltip
                    />
                    <div class="input-group-append">
                        <button
                            class="btn btn-sm btn-outline-danger"
                            type="button"
                            (click)="clearFilter()"
                        >
                            <i class="fas fa-times"></i>
                        </button>
                    </div>
                </div>
            </div>
            @if (searchFilter) {
                <div
                    class="all-filter-results"
                    [class.selected]="!selectedCategory"
                    (click)="filter()"
                >
                    {{ "cerrixIconPicker.allSearchResults" | transloco }}<br />
                </div>
            }
            <div class="categories">
                @for (cat of categories; track cat) {
                    <div
                        class="category"
                        [class.selected]="cat === selectedCategory"
                        (click)="categoryChange(cat)"
                    >
                        {{ cat }}
                    </div>
                }
            </div>
        </div>
        <div class="icons-container">
            <div class="icons">
                @for (icon of filteredIcons | slice: 0 : 150; track icon) {
                    <div
                        class="icon"
                        (click)="changeIcon(icon)"
                        [class.selected]="icon.selector === selectedIcon.selector"
                        [title]="icon.name"
                    >
                        <i class="{{ icon.selector }} fa-2x fa-fw"></i>
                    </div>
                }
            </div>
            <div class="icons-message">
                @if (filteredIcons.length > 150) {
                    <div>
                        {{ "cerrixIconPicker.resultLimitMessage" | transloco }}
                    </div>
                }
            </div>
        </div>
        <div class="right-menu">
            <div class="selected-icon">
                <i
                    class="{{ selectedIcon.selector }}"
                    [class.fa-spin]="animate"
                    [class.fa-border]="border"
                    [style.color]="mainColor | safe: 'style'"
                ></i>
            </div>
            <div class="edit-area">
                <div class="form-group">
                    <label>{{ "cerrixIconPicker.colorLabel" | transloco }}</label>
                    <cerrix-color-select
                        [(value)]="mainColor"
                        [disabled]="!canChangeMainColor"
                    ></cerrix-color-select>
                </div>

                <div class="toggles">
                    <!-- data-uiid: a translated [label] no longer sets the label DOM attribute,
                         so selectors must target the stable uiid instead. -->
                    <cerrix-checkbox
                        data-uiid="icon-picker-animate"
                        [label]="'cerrixIconPicker.animateLabel' | transloco"
                        [(value)]="animate"
                    ></cerrix-checkbox>
                    <cerrix-checkbox
                        data-uiid="icon-picker-border"
                        [label]="'cerrixIconPicker.borderLabel' | transloco"
                        [(value)]="border"
                    ></cerrix-checkbox>
                </div>
            </div>
        </div>
    </div>
</ng-template>
